<ion-header>
  <div class="constrained-content">
    <div class="flex-space-between flexed-align-center" style="padding: 0 13px">
      <div style="margin-bottom: 20px">
        <h3>
          <ion-icon
            name="ticket-outline"
            style="font-size: 1.8rem; margin-right: 5px"
          ></ion-icon>
          Ticket Types & Custom Fields
        </h3>
        <p class="subtitle">
          Categorize new requests and collect additional information depending
          on the type of issue.
          <a
            href="https://docs.unthread.io/conversations/ticket-types"
            target="_blank"
          >
            Learn more
            <ion-icon name="chevron-forward-outline"></ion-icon>
          </a>
        </p>
      </div>
    </div>
    <div style="padding: 5px 0 13px 0px" class="hidden-sm">
      <span
        class="tab-nav-link"
        [ngClass]="{ 'tab-nav-active': tab === 'ticketType' }"
        (click)="selectTab('ticketType')"
      >
        Ticket Types
      </span>
      <span
        class="tab-nav-link"
        [ngClass]="{ 'tab-nav-active': tab === 'customFields' }"
        (click)="selectTab('customFields')"
      >
        Custom Fields
      </span>
    </div>
  </div>
</ion-header>

<ion-content>
  <div class="constrained-content">
    <!-- Ticket Types List View -->
    <div *ngIf="tab === 'ticketType'" style="padding: 15px 2px">
      <div class="flex-space-between" style="padding: 0px 7px 0 0px">
        <div class="button-container flexed-align-center">
          <ion-searchbar
            mode="ios"
            placeholder="Search Ticket Types..."
            showCancelButton="never"
            [(ngModel)]="searchText"
            (ionChange)="handleFilters()"
            class="rounded-search-bar"
            style="margin-left: 0px"
          >
          </ion-searchbar>
        </div>
        <ion-button (click)="createTicketType()">
          <ion-icon name="add-outline"></ion-icon>
          <span class="text-with-left-icon hidden-sm">
            Create Ticket Type
          </span>
        </ion-button>
      </div>
      <ion-card class="outline-card">
        <ngx-datatable
          class="material datatable-row-borders"
          columnMode="force"
          [limit]="100"
          [headerHeight]="46"
          [footerHeight]="50"
          [rowHeight]="52"
          [scrollbarH]="true"
          [rows]="filteredTicketTypes"
          [reorderable]="true"
          [loadingIndicator]="isLoading"
        >
          <ngx-datatable-column
            name="Name"
            prop="name"
            [minWidth]="200"
            [flexGrow]="2"
          >
            <ng-template
              let-value="value"
              let-row="row"
              ngx-datatable-cell-template
            >
              <a class="row-title row-link" (click)="editTicketType(row.id)">{{
                value
              }}</a>
            </ng-template>
          </ngx-datatable-column>

          <ngx-datatable-column
            name="Description"
            prop="description"
            [minWidth]="300"
            [flexGrow]="3"
          >
            <ng-template
              let-value="value"
              let-row="row"
              ngx-datatable-cell-template
            >
              {{ value }}
            </ng-template>
          </ngx-datatable-column>

          <ngx-datatable-column
            name="Created at"
            prop="createdAt"
            [minWidth]="120"
            [maxWidth]="120"
            [flexGrow]="1"
          >
            <ng-template
              let-value="value"
              let-row="row"
              ngx-datatable-cell-template
            >
              {{ value | date: "M/d/yyyy" }}
            </ng-template>
          </ngx-datatable-column>
        </ngx-datatable>
      </ion-card>
    </div>

    <!-- Custom Fields List View -->
    <div *ngIf="tab === 'customFields'" style="padding: 15px 2px">
      <div class="flex-space-between" style="padding: 0px 7px 0 0px">
        <div class="button-container flexed-align-center">
          <ion-searchbar
            mode="ios"
            placeholder="Search Custom Fields..."
            showCancelButton="never"
            [(ngModel)]="customFieldSearchText"
            (ionChange)="handleCustomFieldFilters()"
            class="rounded-search-bar"
            style="margin-left: 0px"
          >
          </ion-searchbar>
        </div>
        <div>
          <ion-button (click)="configureGlobalCustomFields()">
            <ion-icon name="globe-outline"></ion-icon>
            <span class="text-with-left-icon hidden-sm">
              {{ isProjectOwner ? "Configure" : "View" }} Global Custom
              Fields</span
            >
          </ion-button>
          <ion-button (click)="createCustomField()">
            <ion-icon name="add-outline"></ion-icon>
            <span class="text-with-left-icon hidden-sm">
              Create Custom Field
            </span>
          </ion-button>
        </div>
      </div>
      <ion-card class="outline-card">
        <ngx-datatable
          class="material datatable-row-borders"
          columnMode="force"
          [limit]="100"
          [headerHeight]="46"
          [footerHeight]="50"
          [rowHeight]="52"
          [scrollbarH]="true"
          [rows]="filteredCustomFields"
          [reorderable]="true"
          [loadingIndicator]="isLoading"
        >
          <ngx-datatable-column
            name="Label"
            prop="label"
            [minWidth]="200"
            [flexGrow]="2"
          >
            <ng-template
              let-value="value"
              let-row="row"
              ngx-datatable-cell-template
            >
              <a class="row-title row-link" (click)="editCustomField(row.id)">{{
                getCustomFieldLabel(row)
              }}</a>
            </ng-template>
          </ngx-datatable-column>

          <ngx-datatable-column
            name="Type"
            prop="type"
            [minWidth]="120"
            [maxWidth]="150"
            [flexGrow]="1"
          >
            <ng-template
              let-value="value"
              let-row="row"
              ngx-datatable-cell-template
            >
              {{ value?.replace("-", " ") | titlecase }}
            </ng-template>
          </ngx-datatable-column>

          <ngx-datatable-column
            name="Description"
            prop="description"
            [minWidth]="300"
            [flexGrow]="3"
          >
            <ng-template
              let-value="value"
              let-row="row"
              ngx-datatable-cell-template
            >
              {{ value }}
            </ng-template>
          </ngx-datatable-column>

          <ngx-datatable-column
            name="Created at"
            prop="createdAt"
            [minWidth]="120"
            [maxWidth]="120"
            [flexGrow]="1"
          >
            <ng-template
              let-value="value"
              let-row="row"
              ngx-datatable-cell-template
            >
              {{ value | date: "M/d/yyyy" }}
            </ng-template>
          </ngx-datatable-column>
        </ngx-datatable>
      </ion-card>
    </div>
  </div>
</ion-content>
